import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import CONTRACT_ACCESS from '../apiUrls';

const mutationDeactivateMerchantAccount = (onSuccess, onError) => {
    return {
        mutationFn: (merchantAccountUuid) => {
            return client.post(replaceParameters(CONTRACT_ACCESS.DEACTIVATE.url, { uuid: merchantAccountUuid }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeactivateMerchantAccount;